module.exports = __webpack_public_path__ + "static/mBank-6cbabbdf09b4ddd6a63a13d9f4e93c78.png";